import { useCallback, useEffect, useState } from 'react';
import reportService, { LabourDailySummary } from '../../../services/reportService';
import { daysAgoISO } from '../../../utils/dateUtils';

export interface LabourDailyFilter {
  serviceAreaId?: number;
  foremanAreaIds?: number[];
}

/** Labour hours / $ by task type for the home Labour widget, scoped like the other home widgets. */
export function useLabourDaily(enabled: boolean, filter?: LabourDailyFilter) {
  const [data, setData] = useState<LabourDailySummary | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const serviceArea = filter?.serviceAreaId != null ? String(filter.serviceAreaId) : undefined;
  const foremanArea = filter?.foremanAreaIds?.length ? filter.foremanAreaIds.join(',') : undefined;

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      // The user's own calendar day, so "last 7 days" matches what they see
      setData(await reportService.getLabourDailySummary({ today: daysAgoISO(0), serviceArea, foremanArea }));
      setLastUpdated(new Date());
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load labour summary'));
      setData(undefined);
    } finally {
      setLoading(false);
    }
  }, [enabled, serviceArea, foremanArea]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh, lastUpdated };
}
